<template>
  <div class="inner">
    <div class="page_con">
      <div class="table_toggle">
        <div class="btn_wrap">
          <button class="toggle_btn" :class="{'on': onlineType === 1}" @click="onlineType = 1"><span>온라인 교육</span></button><!--'선택 시: on'-->
          <button class="toggle_btn" :class="{'on' : onlineType === 2}" @click="onlineType = 2"><span>집합 교육</span></button>
        </div>
        <p class="table_toggle_txt" v-if="onlineType === 1">※ 아래 학습방 <span>바로가기</span>를 클릭해 교육을 진행하세요.</p><!--이 부분 텍스트도 변경됩니다.-->
        <p class="table_toggle_txt" v-if="onlineType === 2">※ 아래 <span>바로가기</span>를 클릭해 지정확인서를 제출하세요.</p>
      </div>
      <edu-study-list :items="items" :page-info="pageInfo" @study="fnStudy"/>
      <base-list-scroll-page
        v-bind:page="params.page"
        v-bind:currentIndex="currentIndex"
        v-bind:isActive="true"
        v-bind:listFunction="listFunction"
        v-on:finishFetch="fnFinishFetch"
      />
    </div>
    <top-button />
  </div>
</template>

<script>
import EduStudyList from '@/components/pages/edu/study/list'
import TopButton from '@/components/pages/top/button'
export default {
  name: 'edu-study-list-index',
  components: {TopButton, EduStudyList},
  data() {
    return {
      isOnline: true,
      onlineType: 1,
      params: {
        page: 1,
        limit: 10,
        salesType: '',
        isFinishPayment: 1,
        isEnd: -1
      },
      pageInfo: {},
      items: [],
      list2: [],
      type: -1,
      currentIndex: 1
    }
  },
  computed: {
    eduType: function() {
      return this.$store.getters['education/getEduType']
    }
  },
  watch: {
    onlineType: function() {
      this.currentIndex++
    }
  },
  methods: {
    fetchData: async function(page) {
      this.params.page = page
      this.currentIndex++
      const res = this.onlineType === 1 ?  await this.$OnlineClassSvc.fetchUserOnlineClass(this.params) : await this.$OfflineEduSvc.fetchUserOfflineClass(this.params)
      if (res.code === 1) {
        this.items = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
    listFunction: function ({ page }) {
      let params = Object.assign({}, this.params)
      params.page = page
      return this.onlineType === 1 ? this.$OnlineClassSvc.fetchUserOnlineClass(params) : this.$OfflineEduSvc.fetchUserOfflineClass(params)
    },
    fnFinishFetch: function(items, pageInfo) {
      this.items = items
      this.pageInfo = pageInfo
    },
    fnStudy: function(item) {
      if (this.onlineType === 1) {
        this.$router.push({
          path: '/edu/study/room',
          query: { onlineEduNo: item.edu.onlineEduNo, applyEduNo: item.apply.applyEduNo }
        })
      } else {
        this.$router.push({ path: '/edu/hygiene/list' })
      }
    },
    fnView: function(path) {
      this.$router.push({ path: path })
    },
    fnBoard: function(path, boardType) {
      this.$store.commit('education/setBoardType', { boardData: { boardType: boardType } })
      this.$router.push({ path: path })
    }
  }
}
</script>

<style scoped>

</style>
